<!-- Mobile Filter Button -->
<button
  class="btn flex h-10 w-10 btn-outline p-0"
  (click)="showDialog()"
  type="button"
  aria-label="Open filters"
>
  <!-- assets/icons/filter.svg -->
  <svg
    class="h-5 w-5"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 11H17V13H7V11ZM4 7H20V9H4V7ZM10 15H14V17H10V15Z"
      fill="currentColor"
    />
  </svg>
</button>

<!-- Dialog -->
@if (isDialogVisible) {
  <!-- Backdrop overlay -->
  <div
    class="fixed inset-0 z-[999] bg-black transition-opacity duration-300 ease-in-out"
    (click)="closeDialog()"
    (keydown.enter)="closeDialog()"
    (keydown.space)="closeDialog()"
    role="button"
    tabindex="0"
  ></div>
  <div
    class="shadow-xl fixed inset-0 z-[1000] flex h-full flex-col overflow-hidden bg-white transition-transform duration-300 ease-in-out md:hidden"
    role="dialog"
    aria-modal="true"
  >
    <!-- Header -->
    <div class="flex flex-col items-start bg-secondary-background px-6 py-4">
      <div class="flex w-full items-center justify-between">
        <div class="dium leading-7 text-neutral-800">
          {{ 'components.filter.filters' | translate }}
        </div>
        <button
          class="flex items-center gap-2"
          (click)="closeDialog()"
          type="button"
        >
          <span class="text-base leading-normal font-medium text-neutral-600">
            {{ 'common.filter.close' | translate }}
          </span>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.192 6.34424L11.949 10.5862L7.70697 6.34424L6.29297 7.75824L10.535 12.0002L6.29297 16.2422L7.70697 17.6562L11.949 13.4142L16.192 17.6562L17.606 16.2422L13.364 12.0002L17.606 7.75824L16.192 6.34424Z"
              fill="#4A5154"
            />
          </svg>
        </button>
      </div>
    </div>

    <!-- Content -->
    <div class="flex h-full grow flex-col overflow-auto">
      <ng-content></ng-content>
    </div>

    <!-- Footer -->
    <div
      class="flex items-start gap-2 border-t border-neutral-300 px-6 pt-6 pb-8"
    >
      <button
        class="btn-primary btn grow"
        (click)="closeDialog()"
        type="button"
      >
        {{ 'common.filter.showResults' | translate }} ({{ articleAmount() }})
      </button>
      <button
        class="btn btn-outline"
        (click)="resetFilters.emit()"
        type="button"
      >
        {{ 'common.filter.reset' | translate }}
      </button>
    </div>
  </div>
}
